import pagination from '@iso/lib/helpers/pagination';
import { createReducer } from 'reduxsauce';
import initialState from './model';

const {
    actions: baseActions,
    types: paginationTypes,
    reducer: paginationReducer,
} = pagination('promotionList');

const paginationActions = {
    requestFetchPromotionList: baseActions.request,
    fetchPromotionListSucceeded: baseActions.succeeded,
    fetchPromotionListFailed: baseActions.failed,
};

export const types = { ...paginationTypes };

export const actions = { ...paginationActions};

export default createReducer(initialState, {
    // get promotion list
    ...paginationReducer,
});